import { memoize } from "@plansoft-configuration-renderer/utils";
import { ValueSortDirection, ValueSortOrder, } from "../../Attributes/ValueSorting";
// returning 0 a keeps the items as is
const keepSortOrder = () => 0;
const identity = (x) => x;
const createCollator = memoize((languageCode) => new Intl.Collator(languageCode, { numeric: true }));
/**
 * Sort language dependent values by language
 * @param languageCode
 * @returns
 */
function createCompareByProperty(fallbackCompareFn, direction, property, languageCode) {
    const collator = createCollator(languageCode);
    return function compareByStringProperty(a, b) {
        var _a, _b, _c, _d;
        // without fallback to empty string, this fails with null / undefined values
        const result = collator.compare((_b = (_a = a[property]) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "", (_d = (_c = b[property]) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : "");
        const adjustedResult = direction === ValueSortDirection.Descending ? -result : result;
        return adjustedResult || fallbackCompareFn(a, b);
    };
}
const VALUE_SORT_ORDERS = Object.values(ValueSortOrder);
function createComparator(valueSorting, languageCode) {
    return valueSorting.reduceRight((acc, item) => {
        const { order, direction } = item;
        if (VALUE_SORT_ORDERS.includes(order)) {
            return createCompareByProperty(acc, direction, order, languageCode);
        }
        else {
            return keepSortOrder;
        }
    }, keepSortOrder);
}
export function createValueSortFunction(valueSorting, options) {
    const comparator = createComparator(valueSorting, options.localeCode);
    // optimization: skip sorting if no sorting is needed
    if (valueSorting.length === 0) {
        return identity;
    }
    return function sortValues(values) {
        return [...values].sort(comparator);
    };
}
//# sourceMappingURL=createValueSortFunction.js.map